<template>
  <el-input-number :value="value!==0?value:undefined" v-bind="$attrs" :class="customClass" v-on="new$listeners" />
</template>

<script>
export default {
  name: 'CargoInputNumber',
  props: {
    value: { type: Number, default: 0 }
  },
  computed: {
    customClass() {
      let c = 'cargo-input-number'
      if (this.value === 0) {
        c += ' empty-if-zero'
      }
      return c
    },
    new$listeners() {
      return Object.assign(this.$listeners, { input: this.onInput })
    }
  },
  methods: {
    onInput(val) {
      this.$emit('input', val || 0)
    }
  }
}
</script>

<style scoped lang="scss">
.cargo-input-number ::v-deep {
  .el-input-number__increase.is-disabled,
  .el-input-number__decrease.is-disabled {
    pointer-events: none;
  }
}
.cargo-input-number.empty-if-zero ::v-deep {
  .el-input-number__decrease {
    pointer-events: none;
    color: #cccccc;
  }
}
</style>
